import { useContext } from 'react';
import { ExecutiveSummaryContext } from './ExecutiveSummaryContext';

export const useExecutiveSummaryState = () => {
  const context = useContext(ExecutiveSummaryContext);

  if (context === undefined) {
    throw new Error(
      'useExecutiveSummaryState must be within the Context Provider'
    );
  }
  return context;
};
